import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f77b58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SlaActions__inputs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large SlaActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить SLA (id: ${_ctx.state.id})?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_the_select, {
          value: _ctx.state.city_from,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.city_from) = $event)),
          placeholder: "Откуда",
          "is-invalid": _ctx.state_form$.city_from.$error,
          "validation-errors": _ctx.state_form$.city_from.$errors,
          loading: _ctx.data_state.from_cities.is_loading,
          options: _ctx.data_state.from_cities.list,
          failed: _ctx.data_state.from_cities.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          "search-by": "name",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadFromCities(_ctx.data_state.from_cities.pagination.current_page))),
          onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreFromCities(_ctx.data_state.from_cities.pagination.current_page + 1))),
          onSearch: _ctx.searchFromCity,
          onOptionBySearch: _ctx.unshiftFindedFromCity
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          value: _ctx.state.city_to,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.city_to) = $event)),
          placeholder: "Куда",
          "is-invalid": _ctx.state_form$.city_to.$error,
          "validation-errors": _ctx.state_form$.city_to.$errors,
          loading: _ctx.data_state.to_cities.is_loading,
          options: _ctx.data_state.to_cities.list,
          failed: _ctx.data_state.to_cities.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          "search-by": "name",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadToCities(_ctx.data_state.to_cities.pagination.current_page))),
          onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreToCities(_ctx.data_state.to_cities.pagination.current_page + 1))),
          onSearch: _ctx.searchToCity,
          onOptionBySearch: _ctx.unshiftFindedToCity
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.state.periodId,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.periodId) = $event)),
          placeholder: "Период",
          options: _ctx.PERIOD_OPTIONS
        }, null, 8, ["value", "options"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.pickup,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pickup) = $event)),
          "is-invalid": _ctx.state_form$.pickup.$error,
          "validation-errors": _ctx.state_form$.pickup.$errors,
          placeholder: "Забор"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.processing,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.processing) = $event)),
          "is-invalid": _ctx.state_form$.processing.$error,
          "validation-errors": _ctx.state_form$.processing.$errors,
          placeholder: "Обработка"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.transit,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.transit) = $event)),
          "is-invalid": _ctx.state_form$.transit.$error,
          "validation-errors": _ctx.state_form$.transit.$errors,
          placeholder: "Транзит"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.delivery,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.delivery) = $event)),
          "is-invalid": _ctx.state_form$.delivery.$error,
          "validation-errors": _ctx.state_form$.delivery.$errors,
          placeholder: "Доставка"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.state.tariff,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.tariff) = $event)),
          placeholder: "Тариф",
          "is-invalid": _ctx.state_form$.tariff.$error,
          "validation-errors": _ctx.state_form$.tariff.$errors,
          loading: false,
          options: _ctx.SlaTariffs,
          "search-by": "name",
          "select-by": "api_key",
          label: "name",
          onChange: _ctx.onTariffChange
        }, null, 8, ["value", "is-invalid", "validation-errors", "options", "onChange"]),
        (_ctx.isExpress)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 0,
              value: _ctx.state.supplier_id,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.supplier_id) = $event)),
              placeholder: "Поставщик",
              loading: false,
              options: _ctx.SLA_CARRIERS,
              "search-by": "name",
              label: "name",
              class: "mt-1"
            }, null, 8, ["value", "options"]))
          : _createCommentVNode("", true),
        (_ctx.isExpress)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 1,
              label: "Активный",
              value: _ctx.state.is_active,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.is_active) = $event)),
              disabled: _ctx.loading
            }, null, 8, ["value", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 2,
              label: "Уникальный",
              value: _ctx.state.is_unique,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.is_unique) = $event)),
              disabled: _ctx.loading,
              onChange: _ctx.onUniqueChange
            }, null, 8, ["value", "disabled", "onChange"]))
          : _createCommentVNode("", true),
        (_ctx.state.is_unique)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 3,
              placeholder: "Компания",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка компаний произошла ошибка",
              options: _ctx.data_state.companies.list,
              value: _ctx.state.companyId,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.companyId) = $event)),
              "infinite-scroll": "",
              "search-without-refresh": "",
              "is-invalid": _ctx.state_form$.companyId.$error,
              "validation-errors": _ctx.state_form$.companyId.$errors,
              onRefresh: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
              onLoadmore: _cache[17] || (_cache[17] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1)))
            }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}